import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useFormik } from 'formik';
import { Grid, Typography } from '@material-ui/core';
import Button from 'components/Button';
import Select from 'components/Select';

import { loadProvisionalReceiptInfo, updateUniqueSeries } from 'pages/ProvisionalReceiptConfig/store/thunk';

import { useStyles } from './styles';

export default function Sequence() {
  const dispatch = useDispatch();

  const styles = useStyles();

  const { userId } = useSelector(state => state.profile);
  const { establishmentId } = useSelector(state => state.businessInfo);

  const {
    isUniqueSeriesLoading,
    basicInfo: {
      cityCode,
      sequence
    }
  } = useSelector(state => state.provisionalReceiptConfig);

  const handleSubmit = values => {
    dispatch(updateUniqueSeries(userId, establishmentId, values)).then(() => {
      dispatch(loadProvisionalReceiptInfo(userId, establishmentId));
    });
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      sequence: !!sequence ? 1 : 0
    },
    onSubmit: values => handleSubmit(values)
  });

  return(
    <form onSubmit={event => event.preventDefault()}>
      <Grid container>
        <Grid item xs={12} style={{ display: 'flex', gap: 20, alignItems: 'center', marginTop: 30, marginBottom: 20, paddingBottom: 10, borderBottom: '1px solid #E4E7EA' }}>
          <Typography color="primary">
            <b>Série única</b>
          </Typography>
          <Button
            type='submit'
            color='success'
            loading={isUniqueSeriesLoading}
            disabled={!cityCode}
            onClick={formik.handleSubmit}
          >
            Salvar
          </Button>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12} md={5}>
          <Grid container>
            <Grid xs={8} style={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="h6" color="primary" className={styles.text}>
                Geração de RPS única:
              </Typography>
            </Grid>
            <Grid xs={4}>
              <Select
                name="sequence"
                options={[
                  { value: '1', label: 'Sim' },
                  { value: '0', label: 'Não' }
                ]}
                value={formik.values.sequence?.toString()}
                onChange={formik.handleChange}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
}